// src/components/AllTreeContext.js
import React from 'react';
import '../styles/ContextMenu.css';

const AllTreeContext = ({ x, y, onAddToMyDashboards }) => {
  return (
    <div className="context-menu" style={{ top: y, left: x }}>
      <ul>
        <li onClick={onAddToMyDashboards}>Add to My Dashboards</li>
      </ul>
    </div>
  );
};

export default AllTreeContext;